<template>
    <div class="container-nzidoo">
        <loading-spinner v-if="loader" />

        <form v-else class="card mx-2 p-3" method="post" @submit.prevent="updateUser">

            <!-- ACTIONS -->
            <div class="d-flex justify-content-between align-items-start mb-4">
                <button type="button" class="font-weight-bold text-primary mx-0" @click="$router.go(-1)">
                    <i class="mdi mdi-arrow-left mr-2"></i>{{ $t("profile.account.identity") }}
                </button>
                <button type="submit" class="btn-pill font-weight-bold text-primary">
                    {{ $t("action.save") }}
                </button>
            </div>
            <!-- PROFILE HEADER -->
            <div class="text-center mb-4">

                <label>{{ $t("Profile") }}</label>
                <div class="profile-image-wrapper mx-auto mb-2" @click="$refs.picture.click()">
                    <img class="profile-image" :src="pictureOverview ? pictureOverview : storageUrl + user.picture" />
                </div>

                <span class="edit-link" @click="$refs.picture.click()">
                    {{ $t('action.update') }}                </span>

                <input type="file" ref="picture" class="d-none" @change="onPictureChange" accept="image/*" />
            </div>

            <!-- PERSONAL INFO SECTION -->
            <div class="account-title">{{ $t('sentence.personnelInformations') }}</div>


            <!-- BECOME PRO -->
            <div class="is-seller-container mb-4" :class="userUpdate.is_seller == 1 ? 'p-2 rounded-lg' : ''"
                :style="userUpdate.is_seller == 1 ? 'opacity: 0.6; pointer-events: none; ' : ''">
                <label class="toggle-switch">
                    <input type="checkbox" v-model="userUpdate.is_seller" :disabled="userUpdate.is_seller == 1"
                        true-value="true" false-value="false" />
                    <span class="slider round"></span>

                    <span class="toggle-label">{{ $t('Vous etes un Professionel') }}</span>
                </label>
            </div>
            <!-- immatriculation & TVA -->
            <div class="row mb-3" v-if="userUpdate.is_seller === 'true' || userUpdate.is_seller == '1'">
                <div class="col-lg-6 mb-3">
                    <label>{{ $t("attr.immatriculation") }}</label>
                    <input type="text" :class="'form-control ' + { 'is-invalid': has_error && errors.immatriculation }"
                        v-model="userUpdate.immatriculation" />
                    <span class="help-block text-danger" v-if="has_error && errors.immatriculation">
                        {{ errors.immatriculation[0] }}
                    </span>
                </div>
                <div class="col-lg-6 mb-3">
                    <label>{{ $t("attr.tva_number") }}</label>
                    <input type="text" :class="'form-control ' + { 'is-invalid': has_error && errors.num_tva }"
                        v-model="userUpdate.num_tva" />
                    <span class="help-block text-danger" v-if="has_error && errors.num_tva">
                        {{ errors.num_tva[0] }}
                    </span>
                </div>
            </div>


            <!-- GENDER -->
            <div class="gender-toggle">
                <label class="switch-option" :class="{ active: userUpdate.gender === 'FEMALE' }">
                    <input type="radio" name="gender" value="FEMALE" v-model="userUpdate.gender" />
                    <span>{{ $t('Madame') }}</span>
                </label>

                <label class="switch-option" :class="{ active: userUpdate.gender === 'MALE' }">
                    <input type="radio" name="gender" value="MALE" v-model="userUpdate.gender" />
                    <span>{{ $t('Monsieur') }}</span>
                </label>
            </div>
            <span class="help-block text-danger mb-4" v-if="has_error && errors.gender">
                {{ errors.gender[0] }}
            </span>


            <!-- FIRSTNAME & LASTNAME -->
            <div class="row mb-3">
                <div class="col-lg-6 mb-3">
                    <label>{{ $t("attr.firstname") }}</label>
                    <input type="text" :class="'form-control ' + { 'is-invalid': has_error && errors.firstname }"
                        v-model="userUpdate.firstname" />
                    <span class="help-block text-danger" v-if="has_error && errors.firstname">
                        {{ errors.firstname[0] }}
                    </span>
                </div>
                <div class="col-lg-6 mb-3">
                    <label>{{ $t("attr.lastname") }}</label>
                    <input type="text" :class="'form-control ' + { 'is-invalid': has_error && errors.lastname }"
                        v-model="userUpdate.lastname" />
                    <span class="help-block text-danger" v-if="has_error && errors.lastname">
                        {{ errors.lastname[0] }}
                    </span>
                </div>
            </div>

            <!-- BIRTHDAY -->
            <div class="mb-4">
                <label>{{ $t("attr.birthday") }}</label>
                <input type="date" :class="'form-control ' + { 'is-invalid': has_error && errors.birthday }"
                    v-model="userUpdate.birthday" />
                <span class="help-block text-danger" v-if="has_error && errors.birthday">
                    {{ errors.birthday[0] }}
                </span>
            </div>

            <!-- VERIFIED BADGE -->
            <div class="verified-box mb-4" v-if="user.roles && user.roles[0] === 'ROLE_ADMIN'">
                {{ $t("sentence.you_are_admin") }}
            </div>
            <div class="verified-box mb-4" v-else-if="user.validated_client">
                {{ $t("sentence.identity_verified") }}
            </div>
            <div class="unverified-box mb-4" v-else>
                {{ $t("sentence.identity_unverified") }}
            </div>

            <!-- ACCOUNT SECTION -->
            <div class="account-title">{{ $t("sentence.myidentifier") }}</div>

            <div class="mb-3">
                <label>{{ $t("attr.email") }}</label>
                <input disabled type="email" class="form-control" v-model="userUpdate.email" />
            </div>

            <div class="mb-4">
                <label>{{ $t("attr.username") }}</label>
                <input type="text" :class="'form-control ' + { 'is-invalid': has_error && errors.username }"
                    v-model="userUpdate.username" />
                <span class="help-block text-danger" v-if="has_error && errors.username">
                    {{ errors.username[0] }}
                </span>
            </div>
            <div class="mb-4 w-100">
                <div class="d-flex justify-content-between">
                    <router-link
                        class="text-dark text-decoration-none border p-2 rounded d-flex justify-content-between w-100"
                        :to="{ name: 'PasswordPage' }">
                        <label class="mb-0">{{ $t("auth.change-password") }}</label>
                        <i class="mdi mdi-arrow-right font-weight-bold"></i>
                    </router-link>
                </div>
            </div>


        </form>
        <div v-if="!loader" class="card mt-3 p-4 d-flex justify-content-center justify-content-md-end">
            <button @click="showPopUpConfirmation(user.id)" class="unverified-box">
                {{ $t("sentence.deleteAccount") }}
            </button>
        </div>

        <notifications style="top:5%;" width="35%" group="success" position="top center" />
        <notifications style="top:5%;" width="35%" group="error" position="top center" />
        <v-dialog />
    </div>
</template>

<script>
import moment from 'moment';
import config from '@/config';
import LoadingSpinner from '@/components/templates/LoadingSpinner.vue';

export default {
    name: 'AccountInformations',
    components: { LoadingSpinner },
    data() {
        return {
            userUpdate: {},
            has_error: false,
            loader: false,
            errors: {},
            pictureOverview: false,
            storageUrl: config.storageUrl,
        };
    },
    mounted() {
        this.userUpdate=Object.assign({}, this.user);
        if (this.userUpdate.birthday) {
            this.userUpdate.birthday=moment(this.userUpdate.birthday, 'YYYY-MM-DD').format('YYYY-MM-DD');
        }
        delete this.userUpdate.picture;
    },
    computed: {
        user() {
            return this.$store.state.user;
        },
    },
    methods: {
        onPictureChange() {
            this.userUpdate.picture=this.$refs.picture.files[0];
            this.pictureOverview=URL.createObjectURL(this.userUpdate.picture);
        },
        showPopUpConfirmation(userId) {
            var self=this;
            this.$modal.show("dialog", {
                title: "Confirmation",
                text:
                    "<label class='color-red'>Attention ! </label> En supprimant votre compte sur Nzidoo, toutes vos annonces passées et à venir seront supprimées ainsi que votre profil. Un compte supprimè est définitivement perdu",
                buttons: [
                    {
                        title: "Cancel",
                        handler: () => {
                            self.$modal.hide("dialog");
                            return false;
                        },
                    },
                    {
                        title: "Confirmer",
                        handler: () => {
                            self.deleteAccount(userId);
                            self.$modal.hide("dialog");
                        },
                    },
                ],
            });
        },
        updateUser() {
            // Clear previous errors/notifications before a new attempt
            this.has_error=false;
            this.errors={};
            window.scrollTo(0, 0);

            // --- START: Custom Validation for Sellers ---
            let validationFailed=false;

            // Check if the user is marked as a seller
            if (this.userUpdate.is_seller) {

                // Validate Immatriculation
                if (!this.userUpdate.immatriculation) {
                    // We use $set or direct assignment. Using an array [] because your HTML uses [0]
                    this.errors.immatriculation=["L'immatriculation est obligatoire pour un vendeur."];
                    validationFailed=true;
                }

                // Validate Num TVA
                if (!this.userUpdate.num_tva) {
                    this.errors.num_tva=["Le numéro de TVA est obligatoire pour un vendeur."];
                    validationFailed=true;
                }
            }

            // If validation failed, stop here and show error state
            if (validationFailed) {
                this.has_error=true;

                // Optional: Trigger a notification so they know why nothing happened
                this.$notify({
                    group: 'error',
                    title: 'Erreur !',
                    type: 'error',
                    text: 'Veuillez remplir les informations vendeur.'
                });

                return; // Stop execution, do not send API request
            }
            // --- END: Custom Validation ---

            let form=new FormData();
            form.append('username', this.userUpdate.username||'');
            form.append('firstname', this.userUpdate.firstname||'');
            form.append('lastname', this.userUpdate.lastname||'');
            form.append('is_seller', this.userUpdate.is_seller||'');
            form.append('immatriculation', this.userUpdate.immatriculation||'');
            form.append('num_tva', this.userUpdate.num_tva||'');
            form.append('gender', this.userUpdate.gender||'');

            if (this.userUpdate.picture) form.append('picture', this.userUpdate.picture);

            if (this.userUpdate.birthday) {
                form.append('birthday', moment(this.userUpdate.birthday, 'YYYY-MM-DD').format('DD/MM/YYYY'));
            }

            this.loader=true;

            this.$axios.post('user/update/'+this.user.id, form, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
                .then(res => {
                    this.loader=false;

                    if (res.data.success) {
                        if (res.data.data) {
                            this.$store.commit("setUser", {
                                user: res.data.data
                            });
                        } else {
                            // If API doesn't return updated user, update with local data
                            const updatedUser=Object.assign({}, this.user, this.userUpdate);
                            this.$store.commit("setUser", {
                                user: updatedUser
                            });
                        }

                        this.$notify({
                            group: 'success',
                            title: 'Bravo !',
                            type: 'success',
                            text: 'Profil modifié avec succès!'
                        });
                    }
                })
                .catch(err => {
                    window.scrollTo({
                        top: 0,
                        left: 0,
                        behavior: "smooth"
                    });

                    this.loader=false;
                    let errorMessage="Une erreur est survenue !";

                    // Check if detailed error data exists from validation
                    if (err.response&&err.response.data&&err.response.data.data) {
                        this.errors=err.response.data.data;
                        this.has_error=true;
                        errorMessage="Veuillez vérifier les champs et réessayer.";
                    } else if (err.response&&err.response.data&&err.response.data.message) {
                        // General API message from backend
                        errorMessage=err.response.data.message;
                    }

                    this.$notify({
                        group: 'error',
                        title: 'Erreur !',
                        type: 'error',
                        text: errorMessage
                    });
                });
        },
        deleteAccount(userId) {
            var self=this;
            self.loader=true;

            this.$axios({
                url: "user/remove/"+userId,
                method: "POST",
            })
                .then(() => {
                    self.$notify({
                        group: "success",
                        title: "Bravo !",
                        type: "success",
                        text: "Utilisateur supprimé avec succès!",
                    });
                    self.loader=false;
                    self.logout();
                })
                .catch((err) => {
                    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });

                    self.loader=false;
                    let errorMessage="Une erreur est survenue !";

                    // Check if detailed error data exists from validation
                    if (err.response&&err.response.data&&err.response.data.data) {
                        self.errors=err.response.data.data;
                        self.has_error=true;
                        errorMessage="Veuillez vérifier les informations et réessayer.";
                    } else if (err.response&&err.response.data&&err.response.data.message) {
                        // General API message from backend
                        errorMessage=err.response.data.message;
                    }

                    self.$notify({
                        group: "error",
                        title: "Erreur !",
                        type: "error",
                        text: errorMessage,
                    });
                });
        },
    }
};
</script>

<style scoped>
.profile-image-wrapper {
    width: 140px;
    height: 140px;
    border-radius: 50%;
    overflow: hidden;
    border: 3px solid var(--color-d);
    cursor: pointer;
}

.profile-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.edit-link {
    color: #2d9c4a;
    cursor: pointer;
    font-weight: 600;
    font-size: 15px;
}

.account-title {
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 15px;
    margin-top: 10px;
}

.gender-toggle {
    display: flex;
    gap: 20px;
}

.switch-option {
    display: flex;
    align-items: center;
    gap: 6px;
    opacity: 0.5;
}

.switch-option.active {
    opacity: 1;
    font-weight: bold;
}

.verified-box {
    background: #e6ffe6;
    padding: 10px;
    border-radius: 8px;
    font-weight: 600;
    color: #2f7a2f;
    text-align: center;
}

.unverified-box {
    background: #ffe6e6;
    padding: 10px;
    border-radius: 8px;
    font-weight: 600;
    color: #7a2f2f;
    text-align: center;
}

.toggle-switch input:checked+.slider {
    background-color: #7a2f2f;
}

.toggle-switch {
    display: inline-flex;
    align-items: center;
    position: relative;
    cursor: pointer;
    user-select: none;
}

.toggle-switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

.slider {
    position: relative;
    width: 44px;
    height: 24px;
    background-color: var(--color-c);
    transition: .4s;
    margin-right: 15px;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.1);
}

.slider.round {
    border-radius: 24px;
}

.slider:before {
    position: absolute;
    content: "";
    height: 18px;
    width: 18px;
    left: 3px;
    bottom: 3px;
    background-color: white;
    transition: .4s;
    border-radius: 50%;
}

.toggle-switch input:checked+.slider {
    background-color: #7a2f2f;
}

.toggle-switch input:checked+.slider:before {
    transform: translateX(20px);
    background-color: white;
}

.toggle-label {
    font-size: 16px;
    color: var(--color-3);
}
</style>